import { render, staticRenderFns } from "./RelatedContentList.vue?vue&type=template&id=e322853a"
import script from "./RelatedContentList.vue?vue&type=script&lang=js"
export * from "./RelatedContentList.vue?vue&type=script&lang=js"
import style0 from "./RelatedContentList.vue?vue&type=style&index=0&id=e322853a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports